import { Popover as BasePopover } from '@base-ui/react/popover'

export const Trigger = (props: BasePopover.Trigger.Props) => {
  return (
    <BasePopover.Trigger
      delay={0}
      {...props}
    />
  )
}
